var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":"意见详情","visible":_vm.dialogVisible,"before-close":_vm.dialogBeforeClose},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.dialogData.info)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }